import React from 'react';

import ApiResponse from '../../components/message/ApiResponse';
import PlainPage from '../../components/plain/PlainPage';
import FieldString from '../../components/plain/FieldString';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldDatetime from '../../components/plain/FieldDatetime';
import FieldReference from '../../components/plain/FieldReference';

import {FORM_BOOK_TABLE} from '../../util/consts/forms';
import {BOOK_PLAIN_PATH} from '../../util/routes';
import { 
	performApiRequest, ACTION_MREPORT_ITEM_SAVE_API_URL
} from '../../util/restapi'; 
import {formatDateTime} from '../../util/tools';

import iconSpin from '../../assets/icons/spinner-snake.gif';

export const FORM_STATE_READY = 'ready';
export const FORM_STATE_SAVING = 'saving';
export const FORM_STATE_SAVING_ERROR = 'savingError';

class MReportItemPlainModal extends PlainPage {
	
	refBookNodes = [
		{
			classId: 'Book', plainFormPath: BOOK_PLAIN_PATH, 
			selectInstanceFormId: FORM_BOOK_TABLE,
			selectInstanceFormTitle: 'Книга'
		}
	];

	readOnly = false;
	saveResponse = null;

	constructor(props) {
		super(props);
		this.formTitle = 'Елемент звіту';
		this.isModal = true;
		this.state.itemFormState = FORM_STATE_READY;
	}
	componentDidMount = async () => {
		this.init('MReportItem')
	}
	completeInit = async () => {
		if( this.instance && this.instance.id == null ) {
			this.instance.rootField.value.dateTime.value = formatDateTime( new Date() );
			let report = this.props.masterPlain.instance;
			this.instance.rootField.value.reportRef.value = {
			 	id: report.id,
				className: report.model.entityId,
				globalId: report.globalId,
				card: '',
			};
		}
		return true;
	}

	saveItem = async () => {
		this.setState({itemFormState: FORM_STATE_SAVING})

		let bean = this.instance.createBean();
		bean.feVersion = 'plain1';

		let request = {item: bean}
		let response = await performApiRequest(ACTION_MREPORT_ITEM_SAVE_API_URL, request);
		if( response.success ) {
			let table = this.props.table;
			table.updateRow(response.item, this.props.indexBean);
			let inst = this.props.masterPlain.instance;
			inst.setFieldValueByPath('/qty', response.reportQty);
			inst.setFieldValueByPath('/total', response.reportAmount);
			table.closeEditModal();
		} else {
			this.saveResponse = response;
			this.setState({itemFormState: FORM_STATE_SAVING_ERROR})
		}
	}

	createBeanFromInstance(instance) {
		let bean = super.createBeanFromInstance(instance);
		return bean;
	}

	renderBody() {
		let instance = this.state.instance;
		let readOnly = this.readOnly;

		return (
			<div>
				{/* Body */}
				<div style={{padding: '20px'}} >
					<div style={{ display: 'flex', alignItems: 'center'}}>
						<FieldReference instance={instance} path={'/bookRef'} plain={this}
							refNodes={this.refBookNodes}
							readOnly={this.readOnly}
							styles={{divMain: {flexGrow: '1',}}}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '30px',alignItems: 'center'}}>
						<FieldDatetime instance={instance} path={'/dateTime'} plain={this} 
							readOnly={readOnly}
							styleInput={{width: '200px', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/ps'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						<FieldEnum instance={instance} path={'/operation'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						{/*
						<FieldRefList path={'acquirerRef'} instance={instance} plain={plain} readOnly={this.props.readOnly} 
							parentField={fieldGroup} classId={'EBookBank'} styles={{ select: { width: '370px', marginRight: '20px'}}} 
						/>
						*/}
						<FieldString instance={instance} path={'/aid'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '32em'} }}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '30px',alignItems: 'center'}}>
						<FieldString instance={instance} path={'/mid'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '32em', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'/mcc'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
						/>
						<FieldString instance={instance} path={'/tid'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '32em'} }}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '30px',alignItems: 'center'}}>
						<FieldString instance={instance} path={'/bin'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/tranId'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px'} }}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '30px', alignItems: 'center'}}>
						<FieldInteger instance={instance} path={'/qty'} plain={this} 
							readOnly={readOnly}
							styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldDecimal instance={instance} path={'/amount'} plain={this}
							readOnly={readOnly}
							styleInput={{width: '100px', textAlign: 'right',}} 
						/>
					</div>
				</div>
				{this.renderFooter()}
			</div>
		)
	}
	renderFooter() {
		if( this.state.itemFormState == FORM_STATE_READY ) {
			return (
				<div style={{textAlign: 'right', padding: '0 20px 20px 0'}}>
					<button type='button' style={{padding: '3px 20px 3px 20px'}} onClick={this.saveItem}
						title={this.resource.buttonSave}
					>
						{this.resource.buttonSave}
					</button>
				</div>
			)
		}
		if( this.state.itemFormState == FORM_STATE_SAVING) {
			return(
				<div>
					<div style={{marginBottom: '40px', textAlign: 'center'}}>
						<img src={iconSpin} />
					</div>
				</div>
			);
		}
		if( this.state.itemFormState == FORM_STATE_SAVING_ERROR) {
			return(
				<div>
					<ApiResponse response={this.saveResponse} defaultMessage={'Error'}/>
					<div style={{textAlign: 'right', padding: '20px 20px 10px 0'}}>
						<button type='button' style={{padding: '3px 20px 3px 20px'}} 
							onClick={() => {this.setState({itemFormState: FORM_STATE_READY})}}
							title={this.resource.buttonSave}
						>
							{'this.resource.buttonResume'}
						</button>
					</div>
				</div>
			);
		}
	}
}

export default MReportItemPlainModal;
